import { getVar } from "config";

export const useEnv = (): { isDevEnv: boolean } => ({
  isDevEnv: getVar("REACT_APP_ENV") === "dev",
});
